var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-timelinemedia"},_vm._l((_vm.media),function(item,index){return _c('figure',{key:index,class:{
			'is-image': _vm.isImage(item),
			'is-video': _vm.isVideo(item),
		},style:({
			opacity: `${100 - _vm.parallax.ratio.centerToHalf * 100}%`,
		})},[(_vm.isImage(item))?_c('img',{attrs:{"alt":"Timeline Image","src":item}}):(_vm.isVideo(item))?_c('video',{attrs:{"src":item,"autoplay":"","loop":"","muted":"","playsinline":""},domProps:{"muted":true}}):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }